import { Link } from "react-router-dom";
import { Star, Truck, Store, MapPin } from "lucide-react";
import { brl, mediaUrl } from "@/lib/api";

export const ORDER_STATUS = {
  aguardando_pagamento: { label: "Aguardando pagamento", color: "bg-secondary text-muted-foreground" },
  pago: { label: "Pago — em preparo", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300" },
  enviado: { label: "Enviado", color: "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300" },
  pronto_retirada: { label: "Pronto para retirada", color: "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300" },
  entregue: { label: "Entregue", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
  cancelado: { label: "Cancelado", color: "bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300" },
};

export const LISTING_STATUS = {
  pending: { label: "Em análise", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300" },
  approved: { label: "Ativo", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
  rejected: { label: "Recusado", color: "bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300" },
  removed: { label: "Removido", color: "bg-secondary text-muted-foreground" },
};

export const Pill = ({ map, value, testid }) => {
  const s = map[value] || { label: value, color: "bg-secondary" };
  return <span data-testid={testid} className={`rounded-full px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap ${s.color}`}>{s.label}</span>;
};

export const Stars = ({ value = 0, size = "h-4 w-4", onChange, testid }) => (
  <div data-testid={testid} className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} data-testid={onChange ? `star-${n}` : undefined}
        className={onChange ? "transition-transform hover:scale-110" : "cursor-default"}>
        <Star className={`${size} ${n <= Math.round(value) ? "fill-accent text-accent" : "text-muted-foreground/40"}`} />
      </button>
    ))}
  </div>
);

export function ListingCard({ listing, index = 0 }) {
  return (
    <Link to={`/mercado/anuncio/${listing.id}`} data-testid={`listing-card-${listing.id}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card hover-lift fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img src={mediaUrl(listing.images?.[0])} alt={listing.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute left-3 top-3 rounded-full bg-background/90 px-2.5 py-1 text-xs font-semibold">
          {listing.kind === "movel" ? "Móvel pronto" : "Material"}{listing.condition === "usado" ? " · usado" : ""}
        </span>
      </div>
      <div className="p-4">
        <p className="text-xl font-extrabold text-primary">{brl(listing.price)}</p>
        <h3 className="mt-1 line-clamp-2 text-sm font-bold leading-snug">{listing.title}</h3>
        <p className="mt-2 flex items-center gap-1 text-xs text-muted-foreground"><MapPin className="h-3.5 w-3.5" /> {listing.city}/{listing.state}</p>
        <div className="mt-3 flex items-center gap-3 border-t border-border pt-3 text-xs text-muted-foreground">
          {listing.delivery && <span className="flex items-center gap-1"><Truck className="h-3.5 w-3.5" /> Entrega</span>}
          {listing.pickup && <span className="flex items-center gap-1"><Store className="h-3.5 w-3.5" /> Retirada</span>}
          {listing.seller?.reviews_count > 0 && (
            <span className="ml-auto flex items-center gap-1"><Star className="h-3.5 w-3.5 fill-accent text-accent" /> {listing.seller.rating}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
